import imagePreview from './src/main'

imagePreview.install = function (Vue) {
  Vue.component(imagePreview.name, imagePreview)
}

export default imagePreview
